import { PagedListRequestInterface, PagedResponseInterface, PaginatedAPIInterface } from '@vendasta/galaxy/table';
import { ProductListPageTableRow } from './product-list-page-table-row';
import { Observable } from 'rxjs';
import { ProductPageService } from '../product-page.service';

export class ProductListPageDataSource implements PaginatedAPIInterface<ProductListPageTableRow> {
  constructor(readonly productPageService: ProductPageService) {}

  get(req: PagedListRequestInterface): Observable<PagedResponseInterface<ProductListPageTableRow>> {
    const { cursor, pageSize } = req.pagingOptions;
    const { text } = req.searchOptions;
    return this.productPageService.getTableData(cursor, pageSize, text);
  }
}
